import React from 'react';
import { Box, costFormater, Inscription } from '@common-fe/common-fe';

const N_A: string = 'N/A';

interface TriggerAmountProps {
  triggerName?: string;
  triggerAmount?: number;
  isModalView?: boolean;
}

export const TriggerAmount: React.FC<TriggerAmountProps> = ({ triggerName, triggerAmount, isModalView }) => {
  return (
    <Box
      direction="row"
      justify="between"
      align="center"
      pad={{ vertical: isModalView ? 's' : 'm', horizontal: 'm' }}
      round="container2Round"
      background="canvas"
      border={{ color: 'border2', size: '1px' }}
      height={isModalView ? '44px' : '52px'}
    >
      <Inscription color="textBody" lineHeight="20px">
        {triggerName || N_A}
      </Inscription>
      <Inscription color="textBody" lineHeight="20px">
        {triggerAmount ? costFormater(triggerAmount, true) : N_A}
      </Inscription>
    </Box>
  );
};
